import React, { FC, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { updateOwnerActivity } from "../../../../../../Actions/API/AppInstance/AppInstanceActions"
import { getJobFeedbackMessageList } from "../../../../../../Actions/API/Job/JobActions"
import { useJobFeedbackMessageList } from "../../../../../../Hooks/useJobFeedbackMessageList"
import { useAppState } from "../../../../../../Hooks/useReduxState"
import { APIJobFeedbackMessageModel } from "../../../../../../Models/API/JobModel"
import { hasValue } from "../../../../../../Models/Client/FetchState"
import { getEmptyStalePageOrStalePagesContaining } from "../../../../../../Models/Client/RemoteData"
import { JobsList, JobsListProps } from "./JobsList"
import { messageColumns } from "./MessageColumns"

export const MessagesListProvider: FC<
    Omit<JobsListProps, "onVisibleItemsChanged" | "isReviewView">
> = ({ appID, params, ...restParams }) => {
    const dispatch = useDispatch()
    const jobWithFeedbackListFetch = useJobFeedbackMessageList(appID, {
        params,
        refetchOnStale: false
    })
    const [visibleItems, setVisibleItems] = useState<string[]>([])
    const pagesToFetch = useAppState(state =>
        getEmptyStalePageOrStalePagesContaining(
            state.api.jobs.table[appID],
            visibleItems
        )
    )

    useEffect(() => {
        pagesToFetch.forEach(page =>
            dispatch(getJobFeedbackMessageList(appID, params, page))
        )
    }, [appID, dispatch, pagesToFetch, params])

    // update owner activity when this page is mounted
    useEffect(() => {
        if (hasValue(jobWithFeedbackListFetch))
            dispatch(updateOwnerActivity(appID))
    }, [appID, dispatch, jobWithFeedbackListFetch])

    return (
        <JobsList<APIJobFeedbackMessageModel>
            isReviewView={false}
            appID={appID}
            params={params}
            jobListFetch={jobWithFeedbackListFetch}
            {...restParams}
            columns={messageColumns}
            onVisibleItemsChanged={setVisibleItems}
        />
    )
}
